'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Configs = void 0;
var transport_1 = require("../../transport");
var Configs = /** @class */ (function () {
    function Configs() {
    }
    Configs.prototype.getNavigation = function (params) {
        return transport_1.transport.request('configs/navigation', params);
    };
    return Configs;
}());
exports.Configs = Configs;
